import { createActionGroup, props } from '@ngrx/store';
import { TareaActividad } from './tareas.state';

export const TareasActions = createActionGroup({
  source: 'Tareas',
  events: {
    'Load Tareas': props<{ studentId: string }>(),
    'Load Tareas Success': props<{ tareas: TareaActividad[] }>(),
    'Load Tareas Failure': props<{ error: string }>(),
  },
});
